import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { Subscription } from 'rxjs';
import { PermissionsService } from '../../../services/permission.service';
import { DialogConfig, FormField } from '../../../shared/components/reusable-dialog/form-field.interface';

@Component({
  selector: 'app-poc-master',
  standalone: false,
  templateUrl: './poc-master.component.html',
  styleUrl: './poc-master.component.scss'
})
export class PocMasterComponent implements OnInit , OnDestroy {
  title = 'POC Criteria';
  equipments: any[]=[];
  showDialog: boolean = false;
  viewMode: boolean = false;
  formData: any = {};
  cols: any[] = [
    { field: 'sequence', header: 'Ser', filterType: 'text',width: '50px', minWidth: '30px', maxWidth: '100px'  },
    { field: 'name', header: 'Evaluation Element', filterType: 'text' ,  width: '200px', minWidth: '200px', maxWidth: '350px' },
    { field: 'sub_name', header: 'Deliverables for Evaluation', filterType: 'text' ,  width: '200px', minWidth: '200px', maxWidth: '350px'},
    { field: 'total_mark', header: 'Total Marks', filterType: 'text' ,  width: '80px', minWidth: '100px', maxWidth: '150px'},
    { field: 'cut_off', header: 'Cut Off', filterType: 'text' , width: '250px', minWidth: '200px' },
  ];
  selectedequipment: any;
  showDeleteDialog: boolean = false;
  private subscriptions = new Subscription();

  dialogConfig: DialogConfig = {
    title: 'Add POC Criteria',
    width: '80vw',
    height: 'auto',
    maximizable: true,
    closable: true,
    dismissableMask: true,
    formLayout: 'two-column',
    fields: [
      {
        key: 'name',
        label: 'Name',
        type: 'text',
        required: true,
        placeholder: 'Enter Name',
        maxLength: 500,
        validation: {
          required: true,
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Name must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'sub_name',
        label: 'Subname',
        type: 'text',
        required: false,
        placeholder: 'Enter Subname',
        maxLength: 500,
        validation: {
          pattern: '^[a-zA-Z0-9 &]+$'
        },
        patternErrorMessage: 'Subname must be alphanumeric and can include spaces and \'&\' only.'
      },
      {
        key: 'total',
        label: 'Total marks',
        type: 'number',
        required: true,
        placeholder: 'Enter Total marks',
        maxLength: 10,
        validation: {
          required: true,
          pattern: '^[0-9]+$'
        },
        patternErrorMessage: 'Total marks must be a valid number.'
      },
      {
        key: 'cutoff',
        label: 'Qualifying marks',
        type: 'number',
        required: true,
        placeholder: 'Enter Qualifying marks',
        maxLength: 10,
        validation: {
          required: true,
          pattern: '^[0-9]+$'
        },
        patternErrorMessage: 'Qualifying marks must be a valid number.'
      },
      {
        key: 'sequence',
        label: 'Sequence',
        type: 'number',
        required: true,
        placeholder: 'Enter Sequence Number',
        maxLength: 15,
        validation: {
          required: true,
          pattern: '^[0-9]+$'
        },
        patternErrorMessage: 'Sequence must be a valid number.'
      }
    ],
    submitButtonText: 'Submit',
    cancelButtonText: 'Cancel',
    showCancelButton: true
  };


  constructor(private api: ApiService, private messageService: MessageService, private permissionService: PermissionsService) { }

  ngOnInit(): void {
    this.getCriteria();
  }
   ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
totalRecords: number = 0;
  getCriteria(event: { page: number; search?: string } = { page: 1 }) {
     const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/master/poc/criteria/?page=${page}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
   const sub = this.api.getAPI(url).subscribe((res) => {
      this.equipments = res.results ||  res.data 
       this.totalRecords = res.count || 0
    });
    this.subscriptions.add(sub);
  }

  addCriteria() {
    this.viewMode = false;
    this.formData = {};
    this.dialogConfig.title = 'Add POC Criteria';
    this.dialogConfig.submitButtonText = 'Submit';
    this.showDialog = true;
  }

  onSubmitCriteria(formData: any) {
    let payload = {
      name: formData.name,
      sequence: formData.sequence,
      sub_name: formData.sub_name,
      total_mark: formData.total,
      cut_off: formData.cutoff,
    };
    
    if (this.selectedequipment && this.selectedequipment.id) {
      // Update existing criteria
      const sub = this.api.putAPI(`/master/poc/criteria/${this.selectedequipment.id}/`, payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Criteria updated successfully'
          });
          this.showDialog = false;
          this.getCriteria();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res.detail || 'Failed to update criteria'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      // Add new criteria
      const sub = this.api.postAPI('/master/poc/criteria/', payload).subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Criteria added successfully',
          });
          this.showDialog = false;
          this.getCriteria();
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Failed',
            detail: res.name || 'Failed to add criteria',
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }
  viewSystem(rowData: any) {
    this.viewMode = true;
    this.selectedequipment = rowData;
    this.dialogConfig.title = 'View POC Criteria';
    this.dialogConfig.submitButtonText = 'Close';
    this.dialogConfig.showCancelButton = false;
    
    this.formData = {
      name: rowData.name || '',
      sequence: rowData.sequence || '',
      total: rowData.total_mark || '',
      cutoff: rowData.cut_off || '',
      sub_name: rowData.sub_name || '',
    };
    
    this.showDialog = true;
  }

  onUpdateCriteria(equipment: any): void {
    this.viewMode = false;
    this.selectedequipment = equipment;
    this.dialogConfig.title = 'Update POC Criteria';
    this.dialogConfig.submitButtonText = 'Update';
    this.dialogConfig.showCancelButton = true;
    
    this.formData = {
      name: equipment.name || '',
      sequence: equipment.sequence || '',
      total: equipment.total_mark || '',
      cutoff: equipment.cut_off || '',
      sub_name: equipment.sub_name || '',
    };
    
    this.showDialog = true;
  }

  onCancelDialog(): void {
    this.showDialog = false;
    this.selectedequipment = null;
    this.formData = {};
  }

  onCloseDialog(): void {
    this.showDialog = false;
    this.selectedequipment = null;
    this.formData = {};
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedequipment = equipment
  }
  deleteequipment() {
    // this.selectedequipment = equipment;
    let sectionId = this.selectedequipment.id
   const sub = this.api.deleteAPI(`/master/poc/criteria/${sectionId}/`).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Criteria Deleted Successfully',
        });
        this.showDeleteDialog = false
        this.getCriteria();

      },
      error: (err) => {
        console.error('API Error:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete the proposal. Please try again.',
        });
      },
    });
    this.subscriptions.add(sub);

  }
  get canEditSetup(): boolean {
    return this.permissionService.hasPrivilege('/master/poc', 'Edit') ||
           this.permissionService.hasPrivilege('/master/poc', 'Delete')||
           this.permissionService.hasPrivilege('/master/poc', 'View');
  }
}

